<template>
  <banche-e-codici-conto />
</template>

<script>
import BancheECodiciConto from '@/components/ask/pages/tesoreria/BancheECodiciConto.vue'

export default {
  name: 'PageBancheECodiciConto',

  components:{
    BancheECodiciConto
  },

  data(){
    return {
    
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods:{

  },
}
</script>

<style>

</style>
